import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { QBox, QMenuButton } from '@qualio/ui-components';
import AssignFormModal from '../../../EventStepForm/components/AssignFormModal';
import { useAssignees, useFormReassign } from '../../../../hooks';
import { Form } from '../../../../types';

type HeaderButtonGroupKebabMenuProps = {
  data: Form;
  shouldShowKebabMenu: boolean;
  isEditMode: boolean;
  isDisabled: boolean;
};

export const HeaderButtonGroupKebabMenu: React.FC<HeaderButtonGroupKebabMenuProps> = ({
  data,
  shouldShowKebabMenu = false,
  isEditMode = false,
  isDisabled = false,
}) => {
  const { t } = useTranslation();
  const [showReassignModal, setShowReassignModal] = useState(false);
  const { data: users, isLoading: usersLoading } = useAssignees(data.owner_id);
  const { mutateAsync, isLoading: isApiLoading } = useFormReassign();
  const allowedStatesForKebabMenu =
    !isEditMode && ['approval_declined', 'for_review', 'for_approval', 'draft'].includes(data.status);
  const shouldShowMenu = allowedStatesForKebabMenu && shouldShowKebabMenu;

  const handleNewAssigneeSelect = useCallback(
    async (newAssigneeId: string) => {
      await mutateAsync(Number(newAssigneeId));
      setShowReassignModal(false);
    },
    [mutateAsync, setShowReassignModal],
  );

  return shouldShowMenu ? (
    <QBox data-cy="form-options">
      <QMenuButton
        isDisabled={isDisabled}
        buttonLabel="Options"
        iconName="MoreVertical"
        itemSize="sm"
        items={[
          {
            id: 'reassign-step',
            label: t('forms.actions.reassignStep'),
          },
        ]}
        onItemClick={() => setShowReassignModal(true)}
        variant="icon"
      />
      <AssignFormModal
        isOpen={showReassignModal}
        setIsOpen={() => setShowReassignModal(false)}
        onSave={handleNewAssigneeSelect}
        users={users ?? []}
        reassign={true}
        currentAssignedUserName={data.owner_full_name ?? ''}
        isUsersLoading={usersLoading}
        isApiLoading={isApiLoading}
      />
    </QBox>
  ) : null;
};
